import { RELEASE_STATUS_TAG_TYPE, PRODUCT_TAG_TYPE } from "components/pages/whats-new/utils";
import classnames from "classnames";
import { componentStyles } from "./tag.scss";
import { ID_TO_OPTIONS_NAMES_AND_COLORS } from "../../consts";
import Colors from "/styles/colors";
import { BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import { getFilterIcon } from "components/pages/whats-new/utils";

const WhatsNewItemTag = (props) => {
  const { tagId, tagType } = props;

  const tagName = ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]?.data[tagId]?.name;
  const tagTextColor =
    tagType === PRODUCT_TAG_TYPE
      ? ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]?.data[tagId]?.textColor
      : ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]?.textColor;

  const tagBackgroundColor =
    tagType === PRODUCT_TAG_TYPE
      ? ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]?.data[tagId]?.backgroundColor
      : ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]?.backgroundColor;

  return (
    <div
      className={classnames("tag", { "release-status": tagType === RELEASE_STATUS_TAG_TYPE })}
      style={{
        color: tagType !== RELEASE_STATUS_TAG_TYPE ? tagTextColor : Colors[BRAND_BLACK_TEXT_COLOR],
        backgroundColor: tagBackgroundColor
      }}
    >
      <div className="tag-dot" />
      {getFilterIcon(tagName)}
      {tagName}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default WhatsNewItemTag;
